// React hook to use IPInfo service
// ============================================

import { useState, useEffect } from "react";
import ipInfoService from "../services/ipInfoService";

export const useUserLocation = () => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initLocation = async () => {
      try {
        setLoading(true);

        // Initialize IPInfo service
        await ipInfoService.init();

        // Get formatted location for ads
        const locationData = ipInfoService.getLocationForAds();

        console.log("📍 Location ready for ad matching:", locationData);

        setLocation(locationData);
        setError(null);
      } catch (err) {
        console.error("❌ Error initializing location:", err);
        setError(err.message);

        // Fallback to global
        setLocation({
          city: "",
          state: "",
          country: "global",
          zipcode: "",
        });
      } finally {
        setLoading(false);
      }
    };

    initLocation();
  }, []);

  return { location, loading, error };
};
